import { SeasonViewQuery, Gender } from '../../../../../../schema';

export type Quest = NonNullable<SeasonViewQuery['season']>['quests'][number];

export type QuestType = 'SubscribeToWardQuest' | 'OneTimeDonateToWardQuest';

export const QUEST_TYPES: { value: QuestType; label: string }[] = [
  { value: 'SubscribeToWardQuest', label: 'Подписка на подопечного' },
  { value: 'OneTimeDonateToWardQuest', label: 'Разовое пожертвование на подопечного' },
];

export const getQuestTypeLabel = (type: string): string => {
  const questType = QUEST_TYPES.find((t) => t.value === type);
  return questType?.label || type;
};

export type QuestFormValues = {
  title: string;
  description?: string;
  rewardAmount: number | string;
  // Settings for SubscribeToWardQuest / OneTimeDonateToWardQuest
  city?: string;
  gender?: Gender | '' | null;
  minimumCount?: number | string;
};
